import { render, staticRenderFns } from "./DisposalDead.vue?vue&type=template&id=6e974a68&"
import script from "./DisposalDead.vue?vue&type=script&lang=js&"
export * from "./DisposalDead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports